import React from "react";
import { WithTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import NoResultsPlaceholder from "../../../sharedComponents/NoResultsPlaceholder/NoResultsPlaceholder";
import { withTranslationReady } from "../../../common/i18n/withTranslationReady";
import TaxAdvisorClientCard from "../TaxAdvisorClientCard/TaxAdvisorClientCard";
import { GetMyTaxAdvisorCompanyWithClients_getMyTaxAdvisorCompanyWithClients_taxServicesProvided } from "../../graphql/GetMyTaxAdvisorCompanyWithClients";

export interface TaxAdvisorClientAssignment
  extends GetMyTaxAdvisorCompanyWithClients_getMyTaxAdvisorCompanyWithClients_taxServicesProvided {
  endFiscalYear?: number;
}

interface TaxAdvisorClientsWrapperProps extends WithTranslation {
  taxServices: TaxAdvisorClientAssignment[];
}

const TaxAdvisorClientsWrapper = ({ taxServices = [], t }: TaxAdvisorClientsWrapperProps) => {
  const history = useHistory();

  const navigateToCompanyOverview = (taxService: TaxAdvisorClientAssignment) => {
    const clientsPathSegment = taxService.endFiscalYear ? "former-clients" : "client-entities";
    history.push(`/tax-advisor/${clientsPathSegment}/${taxService.client?.id}`);
  };

  const filtered = taxServices.filter((taxService) => taxService.client?.deletedAt === null);

  return (
    <div className="tax-advisor-clients-wrapper">
      {!filtered.length ? (
        <NoResultsPlaceholder text={t("tax-advisor:clients.noClients")} />
      ) : (
        <div data-testid="tax-advisor-clients-list">
          {filtered.map((taxService) =>
            taxService.client !== null ? (
              <TaxAdvisorClientCard
                key={taxService.id}
                taxAdvisorStatus={taxService.taxAdvisorStatus}
                clientName={taxService.client.name}
                clientLegalForm={taxService.client.legalForm}
                clientGroupMemberships={taxService.client.group.memberships}
                brokerageAccounts={taxService.client.brokerageAccounts ?? []}
                endFiscalYear={taxService.endFiscalYear}
                onClick={() => navigateToCompanyOverview(taxService)}
              />
            ) : null
          )}
        </div>
      )}
    </div>
  );
};

export default withTranslationReady("tax-advisor")(TaxAdvisorClientsWrapper);
